import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import omit from '@babel/runtime/helpers/objectWithoutProperties';
import emptyWebGif from 'empty-web-gif';
import { FocusedImage } from 'quintype-js';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { hashString, USED_PARAMS } from './image-utils';
var forceLoadingGumlet = false;

function loadGumlet() {
  if (window.GUMLET_CONFIG || window.gumlet || forceLoadingGumlet === true) {
    return;
  }

  if (process.env.NODE_ENV == 'development') {
    console.warn('Loading Gumlet Dynamically! This is really bad for page speed. Please see https://developers.quintype.com/malibu/tutorial/gumlet-integration');
  }

  forceLoadingGumlet = true;
  window.GUMLET_CONFIG = window.GUMLET_CONFIG || {
    hosts: []
  };
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://cdn.gumlet.com/gumlet.js/2.0/gumlet.min.js';
  document.body.appendChild(script);
}

export function GumletImage(props) {
  var slug = props.slug,
      metadata = props.metadata,
      aspectRatio = props.aspectRatio,
      imageCDN = props.imageCDN,
      imgParams = props.imgParams,
      reactTag = props.reactTag,
      className = props.className,
      priority = props.priority,
      sizes = props.sizes;
  var image = new FocusedImage(slug, metadata);
  var imageProps = {
    src: emptyWebGif,
    'data-src': 'https://' + imageCDN + '/' + image.path(aspectRatio, imgParams),
    key: hashString(slug),
    sizes: sizes
  };

  if (priority) {
    imageProps.fetchPriority = 'high';
  }

  var Tag = reactTag || 'img';
  useEffect(loadGumlet);
  return /*#__PURE__*/React.createElement(React.Fragment, null, priority && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    imagesrcset: imageProps === null || imageProps === void 0 ? void 0 : imageProps.srcSet,
    imagesizes: imageProps === null || imageProps === void 0 ? void 0 : imageProps.sizes
  })), /*#__PURE__*/React.createElement(Tag, _extends({}, imageProps, omit(props, USED_PARAMS), {
    className: className ? "qt-image ".concat(className) : 'qt-image'
  })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("img", {
    src: "https://".concat(imageCDN, "/").concat(image.path(aspectRatio, _objectSpread(_objectSpread({}, imgParams), {}, {
      w: 1200
    }))),
    alt: props.alt || ''
  })));
}